import { defineComponent as _defineComponent } from 'vue'
import {
  TUIGlobal,
  TUIStore,
  StoreName,
  TUIChatService,
  SendMessageParams,
  IConversationModel,
} from "@tencentcloud/chat-uikit-engine";
import {
  defineProps,
  defineEmits,
  toRefs,
  ref,
  defineExpose,
  watch,
} from "../../../adapter-vue";
import MessageInputEditor from "./message-input-editor.vue";
import MessageInputAt from "./message-input-at/index.vue";
import MessageInputButton from "./message-input-button.vue";
import { sendMessages, sendTyping } from "../utils/sendMessage";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  placeholder: {
    type: String,
    default: "this is placeholder",
  },
  replyOrReference: {
    type: Object,
    default: () => ({}),
    required: false,
  },
  isMuted: {
    type: Boolean,
    default: true,
  },
  muteText: {
    type: String,
    default: "",
  },
  enableInput: {
    type: Boolean,
    default: true,
  },
  enableAt: {
    type: Boolean,
    default: true,
  },
  enableDragUpload: {
    type: Boolean,
    default: true,
  },
  enableTyping: {
    type: Boolean,
    default: true,
  },
},
  emits: ["sendMessage", "resetReplyOrReference", "onTyping"],
  setup(__props, { expose, emit }) {

const props = __props




const replyOrReference = ref();
const editor = ref();
const currentConversation = ref<IConversationModel>();
const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isH5 = ref(TUIGlobal.getPlatform() === "h5");

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const onTyping = (inputContentEmpty: boolean, inputBlur: boolean) => {
  sendTyping(inputContentEmpty, inputBlur);
};

const resetReplyOrReference = () => {
  // todo
};

const sendMessage = async () => {
  const messageList =
    editor?.value?.getEditorContent && editor?.value?.getEditorContent();
  await sendMessages(
    messageList,
    currentConversation.value,
    replyOrReference.value
  );
  emit("sendMessage");
  editor?.value?.resetEditor && editor?.value?.resetEditor();
  resetReplyOrReference();
};

const insertEmoji = (emoji: any) => {
  editor?.value?.addEmoji(emoji);
};

const onAtListOpen = () => {
  if(isH5.value){
    editor?.value?.blur();
  }
};

const reEdit = (content: any) => {
  editor?.value?.resetEditor();
  resetReplyOrReference();
  editor?.value?.setEditorContent(content);
};

expose({
  insertEmoji,
  reEdit,
});

return { __sfc: true,props, emit, replyOrReference, editor, currentConversation, isPC, isH5, onTyping, resetReplyOrReference, sendMessage, insertEmoji, onAtListOpen, reEdit, MessageInputEditor, MessageInputAt, MessageInputButton }
}

})